import Notifications from "pages/Notifications/Notifications";
import Home from "pages/Home/Home";
import Profile from "pages/Profile/Profile";

import IncidentsTypes from "pages/Configuration/IncidentsTypes";
import IncidentsCategories from "pages/Configuration/IncidentsCategories";
import IncidentsLocations from "pages/Configuration/IncidentsLocations";
import DisciplinaryActions from "pages/Configuration/DisciplinaryActions";
import Financial from "pages/Configuration/Financial";
import VictimsAndSubjects from "pages/Configuration/VictimsAndSubjects";
import CaseLog from "pages/CaseLog/CaseLog";
import CaseDetails from "pages/Cases/CaseDetails";
import NewCase from "pages/Cases/NewCase";
import EditCase from "pages/Cases/EditCase";
import Statistics from "pages/Statistics/Statistics";

const routes = [
  { path: "/", name: "Home", element: <Home /> },
  { path: "/profile", element: <Profile /> },
  { path: "/notifications", element: <Notifications /> },
  {
    path: "/configuration/incidents-types",
    name: "Configuration - Incidents Types",
    element: <IncidentsTypes />,
  },
  {
    path: "/configuration/categories",
    name: "Configuration - Categories",
    element: <IncidentsCategories />,
  },
  {
    path: "/configuration/locations",
    name: "Configuration - Locations",
    element: <IncidentsLocations />,
  },
  {
    name: "Configuration - Disciplinary Actions",
    path: "/configuration/disciplinary-actions",
    element: <DisciplinaryActions />,
  },
  {
    name: "Configuration - Financial",
    path: "/configuration/financial-loss-recovery",
    element: <Financial />,
  },
  {
    name: "Configuration - Victims and Subjects",
    path: "/configuration/victims-subjects",
    element: <VictimsAndSubjects />,
  },
  {
    path: "/case-log",
    name: "Case Log",
    element: <CaseLog />,
  },
  {
    name: "Cases",
    path: "/cases/:id",
    element: <CaseDetails readOnly={true} />,
  },
  {
    name: "New Case",
    path: "/cases/new-case",
    element: <NewCase />,
  },
  {
    name: "Edit Case",
    path: "/cases/edit-case/:id",
    element: <EditCase />,
  },
  {
    name: "Statistics",
    path: "/statistics",
    element: <Statistics />,
  },
];

export default routes;
